/* eslint import/prefer-default-export: 0 */

export const UPDATE_AUCTIONS_CATALOG = 'UPDATE_AUCTIONS_CATALOGS';
export const UPDATE_ARTWORKS = 'UPDATE_ARTWORKS';
export const UPDATE_META = 'UPDATE_META';
export const SET_CURRENT_USER_ID = 'SET_CURRENT_USER_ID';
export const SET_MEMORISE_STATE = 'SET_MEMORISE_STATE';



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/store/mutation-types.js